const mutations = {
  SET_TRADING_NOTES (state, { trading_notes }) {
    state.trading_notes = trading_notes
  }
}

export default mutations
